import { Abwesenheit } from './Abwesenheit';
import { Arbeitszeit } from './Arbeitszeit';
import { BaseRow } from './BaseRow';
import { RowTypeMap } from './Entities';

export class Konflikt extends BaseRow {
  readonly _type: keyof RowTypeMap = 'konflikt';
  readonly rootArbeitszeit: Arbeitszeit;
  readonly conflictCause: Abwesenheit | Arbeitszeit;

  constructor({
    arbeitszeit,
    conflictCause,
  }: {
    arbeitszeit: Arbeitszeit;
    conflictCause: Abwesenheit | Arbeitszeit;
  }) {
    super();
    this.rootArbeitszeit = arbeitszeit;
    this.conflictCause = conflictCause;
  }
}
